import { WebHaptics, defaultPatterns } from "web-haptics";
class CustomWebHaptics {
    static patterns = defaultPatterns;
    static instance = null;
    cHaptics = null;
    windowNavigator = navigator;
    isReady = false;
    constructor() {
        this.initWebHaptics();
    }
    static getInstance() {
        if (!CustomWebHaptics.instance) {
            CustomWebHaptics.instance = new CustomWebHaptics();
        }
        return CustomWebHaptics.instance;
    }
    initWebHaptics() {
        if (!this.windowNavigator.vibrate) {
            console.warn("Web Haptics API is not supported on this device. Events will only play sounds.");
        }
        if (!WebHaptics.isSupported) {
            console.warn("Vibration API is not supported. Events will only play sounds.");
        }
        try {
            this.cHaptics = new WebHaptics({
                debug: true
            });
            this.isReady = true;
        }
        catch (error) {
            console.error("Failed to initialize Web Haptics:", error);
            this.isReady = false;
        }
    }
    triggerHaptic(patternName) {
        if (!this.isReady || !this.cHaptics) {
            console.warn("Web Haptics not ready. Device may not support haptics.");
            return;
        }
        try {
            const pattern = CustomWebHaptics.patterns[patternName];
            if (!pattern) {
                console.error(`Pattern "${patternName}" not found.`);
                return;
            }
            this.cHaptics.trigger(pattern.pattern);
        }
        catch (error) {
            console.error("Error triggering haptic:", error);
        }
    }
}
export default CustomWebHaptics;
